/*
  Wskakiwanie kart produktów przy przewijaniu (style: fkx-card-reveal.css, bramka html.fkx-reveal w theme.liquid).
  Karty, które wchodzą w ekran razem, dostają kolejne opóźnienia (od lewej, rząd po rzędzie). Nowe karty -
  "Inne itemy" doczytywane po załadowaniu strony i podmiana #MainContent bez przeładowania - łapie MutationObserver.
*/
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('fkx-reveal')) return;
  window.fkxCardReveal = true;

  var SELECTOR = '.product-grid > .grid__item';
  var STEP_MS = 70;
  var MAX_STEPS = 6;

  var io = new IntersectionObserver(
    function (entries) {
      var entering = entries
        .filter(function (entry) {
          return entry.isIntersecting;
        })
        .map(function (entry) {
          return entry.target;
        })
        .sort(function (a, b) {
          var ra = a.getBoundingClientRect();
          var rb = b.getBoundingClientRect();
          return Math.round(ra.top - rb.top) || ra.left - rb.left;
        });

      entering.forEach(function (card, i) {
        io.unobserve(card);
        card.style.setProperty('--fkx-in-delay', Math.min(i, MAX_STEPS) * STEP_MS + 'ms');
        card.classList.add('fkx-in');
      });
    },
    { rootMargin: '0px 0px -6% 0px', threshold: 0.12 }
  );

  function watch(scope) {
    var cards = scope.matches && scope.matches(SELECTOR) ? [scope] : [];
    if (scope.querySelectorAll) cards = cards.concat(Array.prototype.slice.call(scope.querySelectorAll(SELECTOR)));
    cards.forEach(function (card) {
      if (card.classList.contains('fkx-in') || card.hasAttribute('data-fkx-watch')) return;
      card.setAttribute('data-fkx-watch', '');
      io.observe(card);
    });
  }

  watch(document);

  new MutationObserver(function (records) {
    records.forEach(function (record) {
      record.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) watch(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
